import { PIPE_TYPE_REQUEST, CREATE_PIPE_TYPE, GET_PIPE_TYPE, UPDATE_PIPE_TYPE, DELETE_PIPE_TYPE, 
PIPE_TYPE_REQUEST_FAILURE, PIPE_TYPE_REQUEST_SUCCESS, GET_PIPE_TYPE_PAGE } from '../types';

const initialState = {
  pipeTypes: [],
  pipeTypePage: [],
  loading: false,
  error: null,
};

const pipeTypesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PIPE_TYPE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PIPE_TYPE: {
      return {
        ...state,
        pipeTypes: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PIPE_TYPE_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};      
      return {
        ...state,
        pipeTypePage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_PIPE_TYPE:
      return {
        ...state,
        pipeTypes: [action.payload, ...state.pipeTypes],
        loading: false,
        error: null
      };
    case UPDATE_PIPE_TYPE:
      const pipeTypeData = state.pipeTypes.slice(0);
      const uIndex = pipeTypeData.findIndex((data) => data.id === action.payload.id);
      pipeTypeData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        pipeTypes: [ ...pipeTypeData ],
        loading: false,
        error: null
      };
    case DELETE_PIPE_TYPE:
      const pipeType = state.pipeTypes?.slice(0);
      const index = pipeType.findIndex((data) => data.id === action.id);
      if (index > -1) {
        pipeType.splice(index, 1);
      }
      return {
        ...state,
        pipeTypes: [...pipeType],
        loading: false,
        error: null
      }
    case PIPE_TYPE_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case PIPE_TYPE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default pipeTypesReducer;
